import { Box, Typography, useTheme } from "@mui/material";
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { tokens } from "../theme";

// The reporting pages used to render nothing at all when the email check failed -
// no message, no console error - which is indistinguishable from a page that is
// broken. Say so instead.
const AccessDenied = ({ pageName }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
            textAlign={'center'}
            mt={8}
        >
            <LockOutlinedIcon sx={{ fontSize: '3rem', color: colors.grey[300] }} />
            <Typography variant="h4" fontWeight="600" mt={2} color={colors.grey[100]}>
                You don't have access to this page
            </Typography>
            <Typography mt={1} color={colors.grey[300]}>
                {pageName ? `${pageName} is limited to management accounts.` : 'This page is limited to management accounts.'}
                {' '}Ask an administrator if you need access.
            </Typography>
        </Box>
    );
};

export default AccessDenied;
